import { type DesignElementBase } from "..";
import { createIcon } from "../design-element-utils";

const designElement: DesignElementBase = {
  tags: [
    "TikTok GMV",
    "TikTok Organic",
    "tikTok",
    "Tik Tok Organic",
    "TikTok - Organic",
    "Tiktok Ads",
    "TikTok Influencer",
    "Tiktok Organic",
  ],
  iconColor: "#C825A8", // venus
  getIcon(options) {
    return createIcon(
      `<path
        d="M11.0446 12.1851C10.233 12.1851 9.57728 12.8284 9.58927 13.6168C9.59727 14.1228 9.88114 14.5621 10.299 14.8072C10.157 14.5935 10.0731 14.3405 10.0691 14.0679C10.0571 13.2795 10.7128 12.6362 11.5244 12.6362C11.6843 12.6362 11.8383 12.6617 11.9822 12.7068V11.1281C11.8323 11.1065 11.6783 11.0947 11.5244 11.0947C11.5164 11.0947 11.5104 11.0947 11.5024 11.0947V12.2557C11.3585 12.2106 11.2046 12.1851 11.0446 12.1851Z"
        fill="#F00044"
      />
      <path
        d="M14.5531 7.45117H14.5411H14.1252C14.2452 8.04148 14.583 8.55531 15.0548 8.9044C14.745 8.50236 14.5571 8.0003 14.5531 7.45117Z"
        fill="#F00044"
      />
      <path
        d="M17 9.85369C16.842 9.85369 16.6901 9.838 16.5402 9.81055V10.9421C15.9964 10.9421 15.4686 10.8382 14.9729 10.6303C14.653 10.497 14.3551 10.3263 14.0813 10.1204L14.0893 13.6093C14.0853 14.3938 13.7694 15.1292 13.1977 15.6842C12.7319 16.1353 12.1421 16.4236 11.5024 16.5158C11.3525 16.5374 11.1985 16.5491 11.0446 16.5491C10.3609 16.5491 9.70921 16.3314 9.17944 15.9294C9.23942 16 9.30339 16.0686 9.37336 16.1353C9.9491 16.6923 10.7128 17.0002 11.5264 17.0002C11.6803 17.0002 11.8343 16.9884 11.9842 16.9669C12.6239 16.8747 13.2136 16.5864 13.6794 16.1353C14.2512 15.5803 14.567 14.8449 14.571 14.0604L14.5411 10.5715C14.8129 10.7774 15.1108 10.95 15.4327 11.0814C15.9304 11.2873 16.4582 11.3932 17 11.3932"
        fill="#F00044"
      />
      <path
        d="M9.3674 11.9634C9.93715 11.4084 10.6948 11.1005 11.5024 11.0946V10.6769C11.3525 10.6553 11.1986 10.6436 11.0447 10.6436C10.229 10.6436 9.46336 10.9515 8.88761 11.5124C8.32187 12.0634 7.99801 12.8165 8.00001 13.599C8.00001 14.3874 8.31787 15.1268 8.89161 15.6857C8.98357 15.774 9.07753 15.8563 9.17748 15.9309C8.72569 15.4033 8.4798 14.7444 8.4778 14.0501C8.4798 13.2676 8.80165 12.5145 9.3674 11.9634Z"
        fill="#08FFF9"
      />
      <path
        d="M16.5402 9.81036V9.39067H16.5362C15.9805 9.39067 15.4687 9.21024 15.0569 8.9043C15.4147 9.36713 15.9385 9.69661 16.5402 9.81036Z"
        fill="#08FFF9"
      />
      <path
        d="M11.4426 15.4566C11.6325 15.4664 11.8144 15.4409 11.9823 15.3879C12.5621 15.2016 12.9799 14.6721 12.9799 14.0484L12.9819 11.7147V7.45107H14.1254C14.0954 7.30398 14.0794 7.15493 14.0774 7H12.5021V11.2616L12.5001 13.5954C12.5001 14.2191 12.0823 14.7486 11.5025 14.9349C11.3346 14.9898 11.1527 15.0153 10.9628 15.0035C10.7209 14.9898 10.495 14.9192 10.2991 14.8055C10.545 15.1781 10.9648 15.4311 11.4426 15.4566Z"
        fill="#08FFF9"
      />
      <path
        d="M11.5024 16.5157C12.1421 16.4235 12.7319 16.1352 13.1976 15.6842C13.7694 15.1291 14.0852 14.3937 14.0892 13.6092L14.0813 10.1203C14.3531 10.3262 14.651 10.4988 14.9729 10.6302C15.4706 10.8361 15.9984 10.9421 16.5402 10.9421V9.81046C15.9384 9.69671 15.4147 9.36723 15.0568 8.9044C14.585 8.55531 14.2452 8.04148 14.1272 7.45117H12.9817V11.7128L12.9797 14.0466C12.9797 14.6702 12.5619 15.1997 11.9822 15.3861C11.8143 15.441 11.6323 15.4665 11.4424 15.4547C10.9626 15.4292 10.5448 15.1762 10.2989 14.8056C9.88112 14.5624 9.59725 14.1211 9.58925 13.6151C9.57726 12.8267 10.233 12.1835 11.0446 12.1835C11.2045 12.1835 11.3585 12.209 11.5024 12.2541V11.0931C10.6948 11.0989 9.9371 11.4068 9.36735 11.9619C8.8016 12.5129 8.47775 13.266 8.47975 14.0466C8.47975 14.7408 8.72564 15.3998 9.17943 15.9273C9.7112 16.3294 10.3609 16.5471 11.0446 16.5471C11.1985 16.549 11.3525 16.5373 11.5024 16.5157Z"
        fill="#021230"
      />`,
      "#F9E9F6", // venus-2
      options?.borderColor || "#E0E2E6",
      options?.size || "24",
    );
  },
};

export default designElement;
